/** 访客分享落地页判定（request 跳登录、vConsole 自动开启共用） */

export function isInsurancePlanShareLanding(
  pathname: string = typeof location !== 'undefined' ? location.pathname : '',
  search: string = typeof location !== 'undefined' ? location.search : ''
): boolean {
  try {
    const path = String(pathname || '');
    const q = new URLSearchParams(search || '');
    // 分享标 / OAuth 回调 code：计划书、名片、课程等共用
    if (q.get('share') === '1' || q.get('code')) return true;
    return (
      /\/insurance-plan\/proposal\/?$/.test(path) ||
      /\/insurance-plan\/market\/proposal\/?$/.test(path) ||
      /\/insurance-plan\/review\/?$/.test(path) ||
      /\/user\/card\/?$/.test(path)
    );
  } catch {
    return false;
  }
}
